






import { categoryGetters, useCategories, useCurrentComponent } from '@aspenware-library/composables'
import { computed, defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ResortOsBreadcrumbs',
  setup() {
    const { categories } = useCategories()

    const hasSubCategories = computed(() => !!useCurrentComponent()?.$route.params.subcategory)
    const primaryCategory = computed(() => {
      return categories.value.find(cat => cat.SeName === useCurrentComponent()?.$route.params.category)
    })
    const loadedCategory = computed(() => {
      return hasSubCategories.value
        ? primaryCategory.value?.SubCategories.find(cat => cat.SeName === useCurrentComponent()?.$route.params.subcategory)
        : primaryCategory.value
    })

    const breadcrumb = computed(() => {
      const subCategoryCrumb = `<a href="${categoryGetters.getCategoryLink({ category: loadedCategory.value })}" title="${categoryGetters.getCategoryName(loadedCategory.value)}">${categoryGetters.getCategoryName(loadedCategory.value)}</a>`
      const rootCategoryCrumb = `<a href="${categoryGetters.getCategoryLink({ category: primaryCategory.value })}" title="${categoryGetters.getCategoryName(primaryCategory.value)}">${categoryGetters.getCategoryName(primaryCategory.value)}</a>`
      return hasSubCategories.value ? `${rootCategoryCrumb} <span>/</span> ${subCategoryCrumb}` : `${rootCategoryCrumb}`
    })

    return {
      breadcrumb,
      loadedCategory,
    }
  }
})
